// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ot-8";
export var editMode = "_ot-3";
export var headerRow = "_ot-a";
export var headerTitle = "_ot-b";
export var product = "_ot-1";
export var productDetails = "_ot-5";
export var productDivider = "_ot-7";
export var productImage = "_ot-2";
export var productInfo = "_ot-4";
export var productTitle = "_ot-6";
export var strikethrough = "_ot-9";
export var upsellProductsCard = "_ot-0";